import { Dialog, DialogTitle, DialogContent, Box, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import BidQuestionScoringTab from '../../comps/BidQuestionScoringTab'
import { FS_SM, ICON_SM } from '../../common/theme'
import type { Question } from '../../types/question'

interface ScoreDetailsModalProps {
  open: boolean
  onClose: () => void
  // Current question whose `bideval` + answerstructure drive the
  // read-only scoring view. Always renders in the RIGHT column of
  // the comparison layout.
  question?: Question | null
  // Optional previous-version question. When present the scoring
  // breakdown shows inline deltas (pass → fail, count and score
  // changes) for every component of the shared template. Renders
  // in the LEFT column — prev on the left, current on the right.
  prevQuestion?: Question | null
  labelLeft?: string
  labelRight?: string
  title?: string
}

// Read-only popout around BidQuestionScoringTab. In compare mode the
// underlying TaEvalScored renders one merged template with per-row
// deltas, so the dialog stays the same width whether one question or
// two is being shown.
export default function ScoreDetailsModal({
  open, onClose, question, prevQuestion, title,
}: ScoreDetailsModalProps) {
  const noop = () => { /* read-only modal */ }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ 'data-testid': 'score_details_dlg' } as any}
    >
      <DialogTitle sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography component="span" variant="subtitle2" sx={{ fontWeight: 600, fontSize: FS_SM, flex: 1 }}>
          {title ?? 'Estimated Score'}
        </Typography>
        <IconButton size="small" onClick={onClose} data-testid="score_details_close_btn">
          <CloseIcon sx={{ fontSize: ICON_SM }} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 1.25 }}>
        {question ? (
          <BidQuestionScoringTab
            question={question}
            prevQuestion={prevQuestion}
            onScore={noop}
            isLocked={true}
            onToggleLock={noop}
            readOnly
          />
        ) : (
          <Box sx={{ p: 2 }}>
            <Typography variant="caption" sx={{ opacity: 0.6, fontSize: FS_SM }}>
              No score data to show.
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  )
}
